import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div>
      <h1>Política de Privacidade</h1>
      <p>Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos os dados pessoais dos usuários e visitantes do site da Siiota (Switch Industrial IoT for Automation) (referida como "nós", "nosso" ou "empresa"). Nosso objetivo é garantir transparência e fornecer informações claras sobre o tratamento dos dados pessoais.</p>

      <p>Este documento está em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei 13.709/18) e pode ser atualizado para refletir alterações legais. Recomendamos que você consulte esta política periodicamente.</p>

      <h2>1. Dados Coletados</h2>

      <h3>1.1 Dados Pessoais Fornecidos pelo Usuário</h3>
      <p>Coletamos dados pessoais quando você nos fornece diretamente, por exemplo, ao preencher formulários ou interagir conosco.</p>

      <h3>1.2 Tipos de Dados Coletados</h3>
      <p>Podemos coletar os seguintes dados:</p>
      <ul>
        <li>Nome</li>
        <li>E-mail</li>
        <li>Telefone</li>
        <li>Endereço IP</li>
        <li>Informações sobre o uso do nosso software e hardware</li>
      </ul>

      <h2>2. Uso dos Dados Pessoais</h2>
      <p>Utilizamos seus dados pessoais para:</p>
      <ul>
        <li>Melhorar nossos produtos e serviços</li>
        <li>Personalizar sua experiência</li>
        <li>Fornecer suporte ao cliente</li>
        <li>Enviar atualizações e informações relevantes</li>
      </ul>

      <h2>3. Compartilhamento de Dados</h2>
      <p>Podemos compartilhar seus dados pessoais com:</p>
      <ul>
        <li>Autoridades legais, se necessário</li>
        <li>Prestadores de serviços que auxiliam na operação de nosso software e hardware</li>
      </ul>

      <h2>4. Armazenamento de Dados</h2>
      <p>Os dados pessoais são armazenados pelo tempo necessário para cumprir as finalidades descritas nesta política, conforme exigido pela lei. Você pode solicitar a remoção ou anonimização de seus dados, exceto em casos onde a retenção é obrigatória por lei.</p>

      <h2>5. Segurança dos Dados</h2>
      <p>Tomamos medidas para proteger seus dados pessoais contra acesso não autorizado e vazamentos. No entanto, não podemos garantir segurança absoluta contra ataques externos ou erros do usuário.</p>

      <h2>6. Cookies</h2>
      <p>Utilizamos cookies para melhorar sua experiência no nosso site. Cookies são pequenos arquivos armazenados no seu dispositivo que ajudam a personalizar sua navegação. Você pode ajustar as configurações do seu navegador para recusar cookies, embora isso possa afetar a funcionalidade do site.</p>

      <h2>7. Consentimento</h2>
      <p>Ao utilizar nosso site e serviços, você consente com nossa Política de Privacidade. Você pode acessar, atualizar ou cancelar seu cadastro a qualquer momento entrando em contato conosco.</p>

      <h2>8. Alterações na Política</h2>
      <p>Podemos atualizar esta política periodicamente. As mudanças terão efeito imediato após a publicação. Recomendamos que você revise a política regularmente.</p>

      <h2>9. Jurisdição</h2>
      <p>Quaisquer disputas serão resolvidas de acordo com as leis brasileiras e no foro da comarca onde se encontra a sede da empresa.</p>
    </div>
  );
}

export default PrivacyPolicy;
